import styled from "styled-components";

const Wrapper = styled.div`
    padding: 32px;
    display: flex;
    background-color: #fafafa;
    flex-direction: column;
    row-gap: 24px;
    min-height: calc(100vh - 180px);
    .categoryContainer {
        display: flex;
        flex-direction: column;
        row-gap: 12px;
        .categoryTitle {
            font-size: 20px;
            line-height: 32px;
            font-weight: 300;
        }
        .chartsContainer {
            display: flex;
            flex-wrap: wrap;
            gap: 16px;
            max-width: 100%;
            overflow: hidden;
            padding: 16px;
            box-sizing: border-box;
            .chart {
                :hover {
                    color: #2251ff;
                    transform: translate(0, -4px);
                    box-shadow: 0 16px 32px -1px #051c2c33, 0 0 1px #051c2c26;
                }
                cursor: pointer;
                border: 1px #ccc;
                flex: 1 1 calc(33.33% - 32px);
                max-width: 390px;
                min-width: 350px;
                text-align: center;
                font-family: Mckinseysans, sans-serif;
                transition: color, all .2s, opacity .2s;
                box-shadow: 0 2px 4px -1px #0003, 0 0 1px #051c2c26;
                a {
                    flex-flow: column;
                    flex: 1;
                    display: flex;
                    img {
                        width: 100%;
                        height: 160px;
                        display: block;
                        border-radius: 8px;
                    }
                    .chartTitle {
                        grid-column-gap: 16px;
                        grid-row-gap: 16px;
                        border-top: 1px solid #FAFAFA;
                        color: #333333;
                        flex-flow: column;
                        flex: 1;
                        padding: 24px;
                        display: flex;
                        font-size: 18px;
                        font-weight: 300;
                        line-height: 28px;
                        text-decoration: none;
                    }
                }
            }
        }
    }
    .outerAdditionalResourcesContainer {
        border-top: 1px solid #E6E6E6;
        align-self: stretch;
        padding: 16px;
        flex-direction: column;
        align-items: flex-start;
        display: flex;
        .innerAdditionalResourcesContainer {
            z-index: 15;
            flex: none;
            padding: 16px;
            position: relative;
            grid-column-gap: 16px;
            grid-row-gap: 16px;
            align-self: stretch;
            flex-direction: column;
            align-items: flex-start;
            display: flex;
            .title {
                flex: none;
                justify-content: space-between;
                align-self: stretch;
                align-items: center;
                font-weight: 900;
                flex-direction: row;
                align-items: flex-start;
                display: flex;
                font-size: 20px;
            }
            .resourcesList {
                grid-column-gap: 16px;
                grid-row-gap: 16px;
                flex-flow: column;
                flex: none;
                justify-content: flex-start;
                align-self: stretch;
                align-items: flex-start;
                display: flex;
            }
        }
    }
`;

export default Wrapper;